"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFinders = void 0;
const data_hooks_1 = require("@wix/data-hooks");
function createFinders(base, dataHooks) {
    // @ts-expect-error we set handler on an empty object
    return new Proxy(dataHooks, {
        get(obj, element) {
            return {
                find: (options) => base.$((0, data_hooks_1.byDataHook)(dataHooks[element](options))),
                findAll: (options) => base.$$((0, data_hooks_1.byDataHook)(dataHooks[element](options))),
            };
        },
    });
}
exports.createFinders = createFinders;
//# sourceMappingURL=createFinders.js.map